const scriptCache = new Map()

export default function loadScript(url, options = {}) {
  if (!scriptCache.has(url)) {
    const promise = new Promise((resolve, reject) => {
      const script = document.createElement('script')
      script.onerror = () => reject(new Error(`Failed to load '${url}'`))
      script.onload = () => resolve()
      script.async = true
      if (options.id) script.id = options.id
      script.src = url
      document.body.appendChild(script)
    })

    scriptCache.set(url, promise)
  }

  return scriptCache.get(url)
}
